type Endpoint = {
  [key: string]: any;
};

export const ENDPOINTS: Endpoint = {
  assetClassId: (dataEnvironmentId: number) => `${dataEnvironmentId}/asset_classes`,
  assetLookup: (dataEnvironmentId: number) => `${dataEnvironmentId}/asset_lookup`,
  assetSearch: (
    dataEnvironmentId: number,
    searchTerm: string,
    firmNamePropertyDefinitionId: number,
    productNamePropertyDefinitionId: number,
  ) =>
    `${dataEnvironmentId}/asset_search?searchTerm=${searchTerm}&firmNamePropertyDefinitionId=${firmNamePropertyDefinitionId}&productNamePropertyDefinitionId=${productNamePropertyDefinitionId}`,
  assetSelectionSets: (dataEnvironmentId: number) => `${dataEnvironmentId}/asset_selection_sets`,
  bulkMap: (dataEnvironmentId: number) => `/${dataEnvironmentId}/product_upload_assets/bulk_map`,
  currencyCode: (dataEnvironmentId: number) => `${dataEnvironmentId}/currencies`,
  fundStructureId: (dataEnvironmentId: number) => `${dataEnvironmentId}/fund_structures`,
  geographicFocusId: (dataEnvironmentId: number) => `${dataEnvironmentId}/geographic_focuses`,
  investmentFocusId: (dataEnvironmentId: number, assetClassId: number) =>
    `${dataEnvironmentId}/investment_focuses/${assetClassId}`,
  mapAssets: (dataEnvironmentId: number) => `${dataEnvironmentId}/product_upload_assets/map`,
  mappedAssets: (dataEnvironmentId: number) => `${dataEnvironmentId}/mapped_assets`,
  nameAvailability: (dataEnvironmentId: number, name: string) =>
    `${dataEnvironmentId}/product_uploads/name_availability?name=${name}`,
  performanceFrequency: () => 'performance_frequencies',
  productUpload: (dataEnvironmentId: number, productUploadId: string) =>
    `${dataEnvironmentId}/product_uploads/${productUploadId}`,
  productUploads: (dataEnvironmentId: number) => `${dataEnvironmentId}/product_uploads`,
  propertyDefinitions: (dataEnvironmentId: number) => `${dataEnvironmentId}/property_definitions`,
  reportingMethodId: (dataEnvironmentId: number, vehicleTypeId: number) =>
    `${dataEnvironmentId}/reporting_methods?vehicleTypeId=${vehicleTypeId}`,
  unmapAsset: (dataEnvironmentId: number, assetId: string) =>
    `/${dataEnvironmentId}/product_upload_assets/${assetId}/unmap`,
  unmappedUserEnteredProducts: (dataEnvironmentId: number) =>
    `/${dataEnvironmentId}/unmapped_user_entered_products`,
  user: () => '/user',
  vehicleTypeId: (dataEnvironmentId: number) => `${dataEnvironmentId}/vehicle_types`,
};
